import {Directive, TemplateRef} from '@angular/core';

@Directive({
  selector: '[libSafireButtonContent]',
  standalone: true
})
export class SafireButtonContentDirective {

  constructor(public template: TemplateRef<any>) {
  }

}
